export enum DateRangePresetType {
  Today = 'today',
  Yesterday = 'yesterday',
  D7 = '7D',
  D30 = '30D',
  M3 = '3M',
  M6 = '6M',
  M12 = '12M',
  WTD = 'WTD',
  MTD = 'MTD',
  QTD = 'QTD',
  YTD = 'YTD',
  InTheLastXDays = 'last',
  SinceDate = 'since',
  AllTime = 'all',
  Custom = 'custom',
}

export const getPresetTypeForKey = (
  value: string
): keyof typeof DateRangePresetType | undefined => {
  const entries = Object.entries(DateRangePresetType) as [
    keyof typeof DateRangePresetType,
    string,
  ][];
  for (const [key, val] of entries) {
    if (val === value) {
      return key;
    }
  }
  return undefined;
};
